import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash-es';
import { Pagination, Paper } from '@dev/ee-components';

import {
    GetAllPaidNewslettersStart,
    getPaidNewslettersStore,
} from '@/store/paidNewsletters/actions';
import useMobile from '@/services/hooks/useMobile';
import { usePaidNewsletterParamsFromUrl } from '../../../hooks/useRequestParams';



export const CustomPagination = (): JSX.Element => {
    const paidNewsletters = useSelector(getPaidNewslettersStore);
    const dispatch = useDispatch();
    const isMobile = useMobile();
    const params = usePaidNewsletterParamsFromUrl();
  

    const totalCount = paidNewsletters?.loadingTemplates ? 0 : paidNewsletters?.count;

    const changePage = (page: number, perPage: number): void => {
        const offset = page * perPage - perPage;
        dispatch(GetAllPaidNewslettersStart({ ...params, page, limit: perPage, offset }));
    };

    const activePage = params.page;
 
    if (isEmpty(paidNewsletters?.templatesList) && !paidNewsletters?.loadingTemplates) {
        return null;
    }

    if (isMobile) {
        return (
            <Paper padding={{ top: 24, bottom: 24 }}>
                <Pagination
                    dataLength={totalCount}
                    perPage={params.limit}
                    activePage={activePage}
                    handlePaginationChange={changePage}
                    disableBorderTop
                />
            </Paper>
        );
    }
    return(
        <Pagination
            dataLength={totalCount}
            perPage={params.limit}
            activePage={activePage}
            handlePaginationChange={changePage}
        />
    );
};
